import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-300 mt-20" data-testid="site-footer">
      <div className="border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14 grid md:grid-cols-2 gap-6 md:gap-10 items-center">
          <div>
            <h3 className="font-display text-2xl md:text-4xl font-black text-white leading-tight">
              Join the <span className="text-[#FF5A1F]">Steal Club</span>
            </h3>
            <p className="mt-2 md:mt-3 text-xs md:text-sm text-neutral-400 max-w-md leading-relaxed">
              Get early access to drops, an exclusive 10% welcome code and stories of everyday design — straight to your inbox.
            </p>
          </div>
          <form className="flex flex-col sm:flex-row gap-2 w-full" onSubmit={(e) => e.preventDefault()} data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder="you@example.com"
              className="flex-1 min-w-0 h-12 rounded-full bg-white/5 border border-white/15 px-5 text-sm text-white placeholder:text-neutral-500 focus:outline-none focus:border-[#FF5A1F]"
              data-testid="newsletter-input"
            />
            <button
              className="h-12 px-6 rounded-full bg-[#FF5A1F] hover:bg-[#e64a0f] text-white font-semibold text-sm transition whitespace-nowrap"
              data-testid="newsletter-submit"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-[#FF5A1F] flex items-center justify-center text-white font-black">S</div>
            <span className="font-display font-black text-white text-xl">Stealodeal</span>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed max-w-xs">
            Smart, minimal, RFID-protected everyday carry — crafted in India since 2017.
          </p>
          <div className="flex gap-3 mt-5">
            <a className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5" href="#" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5" href="#" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            <a className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5" href="#" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <div className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/card-holders" className="hover:text-[#FF5A1F]">Card Holders</Link></li>
            <li><Link to="/shop/wallets" className="hover:text-[#FF5A1F]">Wallets</Link></li>
            <li><Link to="/shop/keychains" className="hover:text-[#FF5A1F]">Keychains</Link></li>
            <li><Link to="/shop" className="hover:text-[#FF5A1F]">New Arrivals</Link></li>
            <li><Link to="/shop" className="hover:text-[#FF5A1F]">Bestsellers</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Support</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-[#FF5A1F]">Contact Us</Link></li>
            <li><Link to="/about" className="hover:text-[#FF5A1F]">About Stealodeal</Link></li>
            <li><a className="hover:text-[#FF5A1F]" href="#">Shipping & Returns</a></li>
            <li><a className="hover:text-[#FF5A1F]" href="#">Track Order</a></li>
            <li><a className="hover:text-[#FF5A1F]" href="#">Warranty</a></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Get in touch</div>
          <ul className="space-y-3 text-sm text-neutral-400">
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5" /> hello@stealodeal.in</li>
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5" /> +91 99998 37145</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> Devan & Co., New Delhi, India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Stealodeal · Devan & Co. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
